import {
  Link,
  Primary13Regular,
  IconArrowUpRight
} from '@sequencehq/core-components'
import { ComponentProps } from 'react'

const AvalaraTaxCodesSearchLink = (
  linkProps: Pick<ComponentProps<typeof Link>, 'pb'>
) => {
  return (
    <Link
      display="flex"
      alignItems="center"
      to="https://taxcode.avatax.avalara.com/"
      isExternal
      {...Primary13Regular}
      color="indigo.50"
      {...linkProps}
    >
      Search tax codes on avalara.com
      <IconArrowUpRight style={{ display: 'inline', marginLeft: '4px' }} />
    </Link>
  )
}

export default AvalaraTaxCodesSearchLink
